export default "__VITE_ASSET__31ac640c__"